import { Analytics } from '@cobliteam/analytics';
import { Location } from '@cobliteam/common-types';
import useVehicle from '@cobliteam/hooks/src/useEntity/useVehicle';
import { useTranslation } from '@cobliteam/i18n';
import Switch from '@cobliteam/ui/components/Switch';
import Typography from '@cobliteam/ui/components/Typography';
import { filterGetParamDates } from '@cobliteam/ui-business/components/DataTable/components/Filters';
import Page from '@cobliteam/ui-business/components/layout/Page';
import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import VehiclePathsTable from '../components/VehiclePathsTable';

const VehiclePathsPage = () => {
  const history = useHistory();
  const { t } = useTranslation('path-association');
  const [showStops, setShowStops] = useState(false);

  const { vehicleId } = useParams<{ vehicleId: string }>();
  const { data: vehicle } = useVehicle().getVehicle(vehicleId, { enabled: !!vehicleId });

  const handleShowStopsChange = (checked: boolean) => {
    setShowStops(checked);
    if (checked) {
      Analytics.track('Turn On Stop Visualization on Association Page');
    }
  };

  const redirectToAggregatedPage = () => {
    const selectedDate = filterGetParamDates(0);
    const startDate = selectedDate.startDate;
    const endDate = selectedDate.endDate;

    const queryParams = new URLSearchParams(window.location.search);
    queryParams.append('startDate', startDate.toString());
    queryParams.append('endDate', endDate.toString());

    history.push({
      pathname: Location.PATH_ASSOCIATION,
      search: queryParams.toString(),
    });
  };

  return (
    <Page>
      <Page.BackButton label='Voltar' onClick={redirectToAggregatedPage} />

      <Page.Header>
        <Page.Title title={`Trechos ${vehicle?.licensePlate ? `- ${vehicle.licensePlate}` : ''}`} />
        <div className='flex items-center gap-2'>
          <Switch id='show-stops-toggle' size='sm' checked={showStops} onCheckedChange={handleShowStopsChange} />
          <Typography as='label' htmlFor='show-stops-toggle' variant='caption-xs' color='secondary'>
            {t('columns.show_stops_tooltip')}
          </Typography>
        </div>
      </Page.Header>

      <Page.Body>
        <VehiclePathsTable showStops={showStops} />
      </Page.Body>
    </Page>
  );
};

export default VehiclePathsPage;
